import React from 'react';
import { connect } from 'react-redux';
import styles from './Cognition.module.css';
import { DBCheckBox } from '_components';


class PatientCareCenterNoteSubjectiveCognition extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <label className={styles.col1} >Patient appears oriented to:</label>
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGPERSON' className={styles.col2} label='Person' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGPLACE' className={styles.col3} label='Place' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGTIME' className={styles.col4} label='Time' />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let evno = parseInt(noteId.split("_")[1]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isSpeech = state.entities.admissions[epno].discipline === "ST";
    return {
        noteId: noteId,
        evno: evno,
        isPeds,
        isSpeech
    };
}

const connectedPatientCareCenterNoteSubjectiveCognition = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveCognition);
export { connectedPatientCareCenterNoteSubjectiveCognition as PatientCareCenterNoteSubjectiveCognition };

